import { useEffect } from 'react';
import { flushOfflineQueue } from '../services/api';
import { isPublicAppPath } from '../utils/publicAppPaths';

const OfflineSyncManager = () => {
  useEffect(() => {
    const syncIfAllowed = () => {
      if (isPublicAppPath(window.location.pathname)) return;
      flushOfflineQueue();
    };

    const onOnline = () => {
      syncIfAllowed();
    };

    window.addEventListener('online', onOnline);
    // Try once on mount (covers refresh when already online)
    syncIfAllowed();

    return () => {
      window.removeEventListener('online', onOnline);
    };
  }, []);

  return null;
};

export default OfflineSyncManager;

